import React from 'react';

// This is the deprecated Nav3 Account itself, which is removed in KIRBY-14228.
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import AccountMenuNav3 from '@atlassian/account-menu/nav3/account-menu-nav3';

import { AccountInternal, type AccountProps } from './index';

/**
 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-68029 Internal documentation for deprecation (no external access)}
 * Nav3 (`@atlaskit/atlassian-navigation`) support is being removed.
 * This will be removed from the default `@atlassian/account` entrypoint and the `/account/nav3` entrypoint in the next breaking release.
 * Use the default export from `@atlassian/account/nav4` instead.
 */
export const AccountNav3: React.ComponentType<AccountProps> = (props) => {
	return <AccountInternal {...props} AccountMenu={AccountMenuNav3} />;
};
